// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c7c93554","732":"a213b5ed"}[chunkId] + ".chunk.js";
};